class EditMetaModalCtrl {

    constructor($http, $uibModalInstance, invoice, $scope) {
        this.api = $http;

        this.modalInstance = $uibModalInstance;
        this.scope = $scope;

        this.invoiceId = invoice.id;

        this.data = {
            meta_comment: invoice.internal_comment,
            meta_no_payment_reminder: !!invoice.no_payment_reminder,
            meta_annotation: ''+invoice.annotation
        };

        this.submitting = false;
        this.loading = false;

    }

    submit() {
        this.submitting = true;
        return this.api.put('billing/invoices/' + this.invoiceId + '/meta', this.data)
                   .then((response) => this.modalInstance.close())
                   .catch((e) => this.modalInstance.dismiss(e));
    }

    dismiss() {
        this.modalInstance.dismiss(true);
    }
}

EditMetaModalCtrl.$inject = [
    '$http',
    '$uibModalInstance',
    'invoice',
    '$scope'
];

/**
 * @ngdoc object
 * @name billing.invoices.controller:InvoicesEditMetaModalCtrl
 *
 * @description
 *
 */
angular
    .module('festzelt-os.billing.invoices')
    .controller('InvoicesEditMetaModalCtrl', EditMetaModalCtrl);



// WEBPACK FOOTER //
// ./src/app/pages/billing/invoices/controllers/edit-meta-modal-controller.js